import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { NewEditingDialog } from "@/components/forms/new-editing-dialog";
import { editing, type EditingStage } from "@/mocks/data";

export const Route = createFileRoute("/editing")({
  head: () => ({
    meta: [
      { title: "Editing — Studio OS" },
      { name: "description", content: "Editing queue — culling, retouching, and review." },
    ],
  }),
  component: EditingPage,
});

const stages: { key: EditingStage; label: string }[] = [
  { key: "cull", label: "Cull" },
  { key: "edit", label: "Edit" },
  { key: "retouch", label: "Retouch" },
  { key: "review", label: "Review" },
  { key: "done", label: "Done" },
];

function EditingPage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Editing queue"
        description="Track post-production from culling through final delivery."
        actions={<NewEditingDialog />}
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-5">
        {stages.map((stage) => {
          const items = editing.filter((e) => e.stage === stage.key);
          return (
            <div key={stage.key} className="rounded-xl bg-card ring-1 ring-border">
              <div className="flex items-center justify-between border-b border-border px-3 py-2.5">
                <h2 className="text-xs font-semibold uppercase tracking-widest">{stage.label}</h2>
                <span className="rounded bg-surface-muted px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">
                  {items.length}
                </span>
              </div>
              <div className="space-y-2 p-2">
                {items.length === 0 && (
                  <p className="px-2 py-4 text-center text-[11px] text-muted-foreground">Empty</p>
                )}
                {items.map((e) => (
                  <div key={e.id} className="rounded-lg bg-surface-muted/60 p-3 ring-1 ring-border">
                    <p className="truncate text-sm font-medium">{e.gallery}</p>
                    <p className="truncate text-[11px] text-muted-foreground">{e.client}</p>
                    <div className="mt-2 flex items-center justify-between">
                      <span className="font-mono text-[10px] uppercase text-muted-foreground">
                        {e.imageCount} img
                      </span>
                      <StatusBadge status={`due ${e.due}`} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
